/* global google */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { GoogleMap } from '@react-google-maps/api';

import { getBoundsZoomLevel } from '../../../lib/utils';
import RouteMarkers from './route-markers';
import ZonePolygon from './zone-polygon';

function BasicRouteMap(props) {
  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      zoom={props.zoom}
      center={props.center}
    >
      {props.zones.map((zone) => (
        <ZonePolygon key={zone._id} zone={zone} />
      ))}
      <RouteMarkers
        route={props.route}
      />
    </GoogleMap>
  );
}

class BaseRouteMap extends React.Component {
  static DEFAULT_ZOOM_LEVEL = 14;

  static DEFAULT_LAT = 0;

  static DEFAULT_LNG = 0;

  static DEFAULT_CENTER = {
    lat: BaseRouteMap.DEFAULT_LAT,
    lng: BaseRouteMap.DEFAULT_LNG,
  };

  constructor(props) {
    super(props);

    const { route: propsRoute } = props;
    const route = propsRoute || [];

    let center = BaseRouteMap.DEFAULT_CENTER;
    let zoom = BaseRouteMap.DEFAULT_ZOOM_LEVEL;

    const mapBounds = new google.maps.LatLngBounds();
    route.forEach((val) => {
      const coords = get(val, 'geometry.coordinates');
      if (!coords) {
        return undefined;
      }
      mapBounds.extend({ lat: coords[1], lng: coords[0] });
    });

    // height rounded down to 712 - weird issues noticed on differnt screen sizes
    zoom = getBoundsZoomLevel(mapBounds, {
      width: document.documentElement.clientWidth,
      height: Math.min(document.documentElement.clientHeight, 712),
    }) - 1;

    center = mapBounds.getCenter();
    this.state = {
      zoom,
      center,
    };
  }

  get route() {
    const { route } = this.props;
    return route || [];
  }

  render() {
    const {
      zoom,
      center,
    } = this.state;
    return (
      <div id="map" style={{ height: '500px', width: '100%' }}>
        <BasicRouteMap
          ref={(ref) => {
            this.map = ref;
          }}
          containerElement={<div style={{ height: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          zoom={zoom}
          center={center}
          route={this.route}
          zones={this.props.zones}
        />
      </div>
    );
  }
}
BaseRouteMap.defaultProps = {
  route: [],
  zones: [],
};
BaseRouteMap.propTypes = {
  route: PropTypes.arrayOf(PropTypes.object),
  zones: PropTypes.arrayOf(PropTypes.object),
};

const RouteMap = withRouter(BaseRouteMap);
export { BaseRouteMap, RouteMap };
export default RouteMap;
